import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as bs58check from 'bs58check';
/**
 * @internalapi
 *
 * The Serializer is used to serialize / deserialize JSON objects and encode them with bs58check
 */

export var Serializer = /*#__PURE__*/function () {
  function Serializer() {
    _classCallCheck(this, Serializer);
  }

  _createClass(Serializer, [{
    key: "serialize",
    value:
    /**
     * Serialize and bs58check encode an object
     *
     * @param message JSON object to serialize
     */
    function serialize(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var str;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                str = JSON.stringify(message);
                return _context.abrupt("return", bs58check.encode(Buffer.from(str)));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * Deserialize a bs58check encoded string
     *
     * @param encoded String to be deserialized
     */

  }, {
    key: "deserialize",
    value: function deserialize(encoded) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof encoded !== 'string')) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Encoded payload needs to be a string');

              case 2:
                return _context2.abrupt("return", JSON.parse(bs58check.decode(encoded).toString()));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }]);

  return Serializer;
}();